import React from 'react'
import styled from 'styled-components'
import { NavBar } from './navbar'
import ButtonGroup from './button-group'
import { FONTS } from '../../../constants'

export default class Tab extends React.Component {
  render() {
    return (
      <Wrapper>
        <NavBar { ...this.props } />
        <ButtonGroup { ...this.props } />
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 50px ;
  width: 100%;
`




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab/index.js